import * as turndownPluginGfm from 'joplin-turndown-plugin-gfm';
import MarkdownConverter from 'turndown-rn';

const markdownConverter = new MarkdownConverter({ emDelimiter: '*' });
markdownConverter.addRule('underline', {
  filter: ['u'],
  replacement: (content: string) => '++' + content + '++',
});
markdownConverter.use(turndownPluginGfm.tables);

export default markdownConverter;
